import { Timer } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const TimerIcon = DeckardIconWrapper({ Icon: Timer });
